import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import SalesTargetListPageUI from './SalesTargetListPageUI';

class SalesTargetListPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      salesTargetList: [],
      filteredSalesTargetList: [],
      selectedTarget:null,
      userIdList: [],
      userIdSList: [],
      monthList:[],
      yearList:[],
      salesChannelList: [],
      filteredList:[],
      createSalesTargetMode: false,
      updateSalesTargetMode: false,
      month:'null',
      channel:'null',
      originator:'null',
      downloadSubmitted: null,
      totals:null,

    };
  }

  render() {
    return (
      <SalesTargetListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        selectedTarget={this.state.selectedTarget}
        salesTargetList={this.state.salesTargetList}
        filteredSalesTargetList={this.state.filteredSalesTargetList}
        yearList={this.state.yearList}
        createSalesTargetMode={this.state.createSalesTargetMode}
        onCreateSalesTargetClick={() => { this.setState({ createSalesTargetMode: true }) }}
        onCreateSalesTargetCancel={() => { this.setState({ createSalesTargetMode: false }) }}
        //
        updateSalesTargetMode={this.state.updateSalesTargetMode}
        onUpdateSalesTargetClick={this.onUpdateSalesTargetClick}
        onUpdateSalesTargetCancel={() => {this.setState({updateSalesTargetMode:false})}}

        onRefreshClick={this.onRefreshClick}
        //
        month={this.state.month}
        onFilterChange={this.onFilterChange}
        monthList={this.state.monthList}
        //
        channel={this.state.channel}
        onChannelChange={this.onFilterChange}
        salesChannelList={this.state.salesChannelList}
        //
        originator={this.state.originator}
        onOriginatorChange={this.onFilterChange}
        userIdSList={this.state.userIdSList}
        //
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        totals={this.state.totals}
        
      />
    );
  }

  componentDidMount() {
    const { context } = this.props;
    this.getUsers(context);
    this.getUsersS(context);
    this.getFilteredMonthList();
    this.getFilteredYearList();
    this.getSalesChannels(context);
    this.getSalesTargetList(context);
  }

  getSalesTargetList(context) {
    const { channel, month, originator } = this.state;  // Extract state values

    const resource = `/api/su/sales/targets?channel=${channel}&month=${month}&userId=${originator}`;
    console.log('Resource:', resource);
    const cacheManager = new CacheManager({
        resource: resource,  // Include query parameters
        cacheKey: CacheKeys.SalesTargetList(this.state.channel, this.state.month, this.state.originator),  // Use the cache key
        callback: this.getSalesTargetListCallback,
        ttlInSecs: 600,
    });

    cacheManager.getObject2(context);
}


  getSalesTargetListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      salesTargetList: response.salesTargetList,
      filteredSalesTargetList: response.salesTargetList,
      totals: response
    });
  };

  onFilterChange = (option, filterType) => {
    // Update the state based on the filter type
    console.log('Filter Type:', filterType);  

    if (filterType === 'month') {
      this.setState({ month: option.value }, () => {
        console.log("calling")
        this.getSalesTargetList(this.props.context);
      });
    } else if (filterType === 'channel') {
      this.setState({ channel: option.value }, () => {
        console.log("calling")

        this.getSalesTargetList(this.props.context);});
    } else if (filterType === 'originator') {
      this.setState({ originator: option.value }, () => {
        console.log("calling")

        this.getSalesTargetList(this.props.context);
       });
    }
    else {
      this.getSalesTargetList(this.props.context);
    }
  };

  

  getFilteredMonthList() {
    let months = [
      { value: '01', label: 'Jan' },
      { value: '02', label: 'Feb' },
      { value: '03', label: 'Mar' },
      { value: '04', label: 'Apr' },
      { value: '05', label: 'May' },
      { value: '06', label: 'Jun' },
      { value: '07', label: 'Jul' },
      { value: '08', label: 'Aug' },
      { value: '09', label: 'Sep' },
      { value: '10', label: 'Oct' },
      { value: '11', label: 'Nov' },
      { value: '12', label: 'Dec' },
    ];

    let filteredMonths = months.map(month => ({
      key: month.value,
      value: month.label,
      label:month.label
    }));
    let newFilteredMonths = [{value: 'null', label : 'All'},...filteredMonths]
    this.setState({ monthList: newFilteredMonths });
  }

  getFilteredYearList() {
    let years = [
      { value: '2024', label: '2024' },
      { value: '2025', label: '2025' },
    ];
    let filteredYears = years.map(year => ({
      key: year.value,
      value: year.label
    }));
    this.setState({yearList: filteredYears})
  }

  getUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.Users(),
      callback: this.getUsersCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getUsersCallback = (response) => {
    let list = response.userList.map(user => ({
      key: user.userId,
      value: user.addressableName,
      label:user.addressableName
    }));
    let newUserList = [{value:'null', label: 'All'}, ...list]
    this.setState({errorList: response.errorList, userIdList:newUserList});
  };

  getUsersS(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.Users(),
      callback: this.getUsersSCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getUsersSCallback = (response) => {
    let list = response.userList.map(user => ({
      value: user.userId,
      label:user.addressableName
    }));
    let newUserList = [{value:'null', label: 'All'}, ...list]
    this.setState({errorList: response.errorList, userIdSList:newUserList});
  };

  getSalesChannels(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/salesChannels`,
      cacheKey: CacheKeys.SalesChannel(),
      callback: this.getSalesChannelsCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getSalesChannelsCallback = (response) => {
    let salesChannelList = response.salesChannelList.map(channel => ({
      key: channel.code,
      value: channel.name,
      label:channel.name
    }));
    let newSalesChannelList = [{ value: 'null', label: 'All' }, ...salesChannelList]
    this.setState({errorList: response.errorList, salesChannelList: newSalesChannelList });
  };

  onUpdateSalesTargetClick = (event) => {
    let salesTargetId = event.currentTarget.getAttribute('sales-target-id');
    let selectedSalesTarget = this.state.salesTargetList.filter(st => st.salesTargetId === salesTargetId)[0];
    this.setState({ updateSalesTargetMode: true, selectedTarget: selectedSalesTarget });
  };
  
  onDownloadClick = () => {
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    });

    RestApiUtils.get(
      this.props.context,
      `/api/su/sales/targets/excel/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, 
      null, 
      { channel: this.state.channel, month: this.state.month, userId: this.state.originator }
    );
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    });

    if (response.errorList.length === 0) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  
  onRefreshClick = () => {
    const { context } = this.props;
    CacheManager.removeObject(CacheKeys.SalesTargetList(this.state.channel, this.state.month, this.state.originator));
    CacheManager.removeObject(CacheKeys.Users()); 
    CacheManager.removeObject(CacheKeys.SalesChannel());

    this.setState({
      userIdList:[],
      salesTargetList: null,
      filteredSalesTargetList: null,
      yearList:[],
      monthList:[],
      errorList: null,
    });
    this.getUsers(context);
    this.getFilteredMonthList();
    this.getFilteredYearList();
    this.getSalesTargetList(context);
  };
}

export default withRouter(SalesTargetListPageSF);
